import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../../store/authStore';
import { MERCHANT_ALLOWED_MODULES, MERCHANT_ALWAYS_ALLOWED_PATHS, MERCHANT_ONLY_PATHS, MERCHANT_PATH_REQUIRED_ACTION } from '../constants/constants';

// Documentation is otherwise a MERCHANT_ONLY_PATHS entry (self-service API docs), but a referral
// admin's sidebar also exposes it (see DashboardLayout's REFERRAL_ADMIN_VISIBLE_PATHS) — without
// this exception, following that link would immediately bounce them back to /dashboard/transaction-dashboard below.
const REFERRAL_ADMIN_ALLOWED_PATHS = new Set<string>(['/documentation']);

export function RequireModule({ path, children }: { path: string; children: React.ReactNode }) {
  const user = useAuthStore((state) => state.user);
  const isReferralAdmin =
    user?.userType === 'ADMIN' && String(user?.adminType ?? '').trim().toUpperCase() === 'ADMIN';

  if (user?.userType !== 'MERCHANT') {
    if (MERCHANT_ONLY_PATHS.has(path) && !(isReferralAdmin && REFERRAL_ADMIN_ALLOWED_PATHS.has(path))) {
      return <Navigate to="/dashboard/transaction-dashboard" replace />;
    }
    return <>{children}</>;
  }

  if (MERCHANT_ALWAYS_ALLOWED_PATHS.has(path)) return <>{children}</>;

  const requiredModule = MERCHANT_ALLOWED_MODULES[path];
  const requiredAction = MERCHANT_PATH_REQUIRED_ACTION[path] ?? 'view';
  const hasAccess = !!requiredModule && (user.moduleAccesses ?? [])
    .some((access) => {
      if (access.moduleCode !== requiredModule) return false;
      if (requiredAction === 'create') return !!access.canCreate;
      if (requiredAction === 'update') return !!access.canUpdate;
      return !!access.canView;
    });

  return hasAccess ? <>{children}</> : <Navigate to="/dashboard/transaction-monitoring" replace />;
}
